export const getParentUrl = (isExpandedWindow) => {
  return new Promise((resolve, reject) => {
    // For expanded window, check URL from query params
    if (isExpandedWindow) {
      const urlParams = new URLSearchParams(window.location.search);
      const url = urlParams.get('url');
      
      if (!url) {
        const error = new Error('URL parameter is missing');
        error.code = 'MISSING_URL_PARAM';
        reject(error);
        return;
      }

      try {
        const decodedUrl = decodeURIComponent(url);
        new URL(decodedUrl); // Validate URL format
        resolve(decodedUrl);
      } catch (error) {
        error.code = 'INVALID_URL_FORMAT';
        reject(error);
      }
      return;
    }

    // For embedded iframe, request URL from parent
    const messageHandler = (event) => {
      if (event.data.type === 'PARENT_URL_PATH') {
        window.removeEventListener('message', messageHandler);
        if (!event.data.fullUrl) {
          const error = new Error('Parent URL not provided');
          error.code = 'MISSING_PARENT_URL';
          reject(error);
          return;
        }
        resolve(event.data.fullUrl);
      }
    };

    window.addEventListener('message', messageHandler);
    window.parent.postMessage({ type: 'GET_PARENT_URL' }, '*');

    // Timeout fallback
    setTimeout(() => {
      window.removeEventListener('message', messageHandler);
      const error = new Error('Timeout while getting parent URL');
      error.code = 'URL_TIMEOUT';
      reject(error);
    }, 5000);
  });
};
